import { isInPTO } from "../../../utils/dateUtils";
import type { Nurse, NurseInShift } from "../../../utils/models";

/**
 * The note on the time off that removed a shift — the person's time-off entry overlapping the shift — as the
 * Detailed printout's "Include time off reason" prints it (mapping §9.3). "" when no entry overlaps or the entry
 * has no note.
 */
export const timeOffReasonOf = (shift: NurseInShift, nurses: Nurse[], dayStart: string): string => {
	const fullNurse = nurses.find((nurse) => nurse.id === shift.nurseId);
	const matchingPref = fullNurse?.employeeSpecificPreferences.find((pref) => isInPTO(pref, shift.startTime, dayStart, shift.endTime));
	// DEFAULT: no overlapping entry, or one without a note, is a real state the printout shows as a blank reason.
	return matchingPref?.notes ?? "";
};
